module.exports = __webpack_public_path__ + "04_glasses_black.8bc7a82b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer4/04_glasses_black.png
// module id = b29H
// module chunks = 0